import { useEffect, useMemo, useState } from 'react';

import { subscribeHomeClicks } from 'helpers/homeClicks';

const CATS = {
	govyadina: 'Говядина',
	baranina: 'Баранина',
	ptitsa: 'Птица',
	'polufabrikaty-ohlazhd': 'Полуфабрикаты охлаждённые',
	'polufabrikaty-zamorozh': 'Полуфабрикаты замороженные',
	'kolbasnye-izdeliya': 'Колбасные изделия',
	delikatesy: 'Деликатесы',
	kulinariya: 'Кулинария',
	marinady: 'Маринады',
	'korm-dlya-zhivotnyh': 'Корм для животных',
	'soputstvuyushtie-tovary': 'Сопутствующие товары',
	subprodukty: 'Субпродукты',
};

const PAGES = {
	'/': 'Главная',
	'/catalog': 'Каталог',
	'/cart': 'Корзина',
	'/contact': 'Контакты',
	'/news': 'Новости',
	'/reviews': 'Отзывы',
	'/privacy': 'Конфиденциальность',
	'/account': 'Личный кабинет',
	'/account/history': 'История заказов',
	'/account/wishlist': 'Избранное',
	'/account/password': 'Смена пароля',
	'/page/4': 'О компании',
	'/page/6': 'Отзывы о магазине',
	'/page/9': 'Вакансии',
	'/page/15': 'Доставка и оплата, Нальчик',
	'/page/16': 'Доставка и оплата, Москва',
	'/page/20': 'Сертификаты',
	'/page/promotions': 'Акции',
	'/page/stores': 'Магазины',
	'/stats': 'Эта страница',
};

const EXACT = {
	banner: ['Нажали на баннер', 'Главная', 'Главная'],
	'to-catalog': ['Нажали «В каталог»', 'Главная, блок популярных', 'Главная'],
	'city:yes': ['Подтвердили город', 'Окно «Это ваш город?»', 'Окна'],
	'city:no': ['Отказались от города', 'Окно «Это ваш город?»', 'Окна'],
	'city:close': ['Закрыли выбор города', 'Окно «Это ваш город?»', 'Окна'],
	'nav:catalog': ['Открыли каталог', 'Кнопка в шапке', 'Шапка и меню'],
	'nav:menu': ['Открыли меню', 'Кнопка в шапке телефона', 'Шапка и меню'],
	'nav:menu-close': ['Закрыли меню', 'Шапка телефона', 'Шапка и меню'],
	'nav:catalog-close': ['Закрыли каталог', 'Шапка телефона', 'Шапка и меню'],
	'btn:Да': ['Подтвердили город', 'Окно «Это ваш город?»', 'Окна'],
	'btn:Нет': ['Отказались от города', 'Окно «Это ваш город?»', 'Окна'],
	'btn:Каталог': ['Открыли каталог', 'Кнопка в шапке', 'Шапка и меню'],
	'btn:Меню': ['Открыли меню', 'Кнопка в шапке телефона', 'Шапка и меню'],
	'btn:close': ['Закрыли окно', 'Крестик', 'Окна'],
	'btn:Close': ['Закрыли окно', 'Крестик', 'Окна'],
	'btn:Закрыть': ['Закрыли окно', 'Крестик', 'Окна'],
	'btn:plus': ['Увеличили количество', 'Плюс у товара', 'Корзина'],
	'btn:Plus': ['Увеличили количество', 'Плюс у товара', 'Корзина'],
	'btn:minus': ['Уменьшили количество', 'Минус у товара', 'Корзина'],
	'btn:Нальчик': ['Выбрали Нальчик', 'Переключатель города', 'Шапка и меню'],
	'btn:Москва': ['Выбрали Москву', 'Переключатель города', 'Шапка и меню'],
	'btn:Контакты': ['Открыли контакты', 'Пункт меню', 'Шапка и меню'],
	'btn:О компании': ['Открыли «О компании»', 'Подвал сайта', 'Страницы'],
	'a:Контакты': ['Открыли контакты', 'Пункт меню', 'Шапка и меню'],
	'a:О компании': ['Открыли «О компании»', 'Подвал сайта', 'Страницы'],
};

const GROUPS = ['Все', 'Главная', 'Каталог', 'Товары', 'Корзина', 'Шапка и меню', 'Страницы', 'Окна', 'Остальное'];

function pageTitle(path) {
	if (PAGES[path]) return PAGES[path];
	if (path.startsWith('/catalog/')) {
		const slug = path.slice('/catalog/'.length);
		return `Раздел «${CATS[slug] || slug}»`;
	}
	if (path.startsWith('/product/')) return 'Карточка товара';
	if (path.startsWith('/news/')) return 'Новость';
	if (path.startsWith('/account/history/')) return 'Заказ в кабинете';
	return path;
}

function hostTitle(host) {
	if (host.includes('rustore')) return 'Ссылка на RuStore';
	if (host.includes('play.google')) return 'Ссылка на Google Play';
	if (host.includes('apple.com')) return 'Ссылка на App Store';
	if (host.includes('is.rayanhalal')) return 'Ссылка на сайт контрагентов';
	return `Внешняя ссылка ${host}`;
}

function namedAction(text) {
	const known = {
		Да: ['Подтвердили город', 'Окно «Это ваш город?»'],
		Нет: ['Отказались от города', 'Окно «Это ваш город?»'],
		Telegram: ['Открыли Telegram', 'Соцсети в подвале'],
		VK: ['Открыли ВКонтакте', 'Соцсети в подвале'],
		WhatsApp: ['Открыли WhatsApp', 'Соцсети в подвале'],
		'anticon-plus': ['Увеличили количество', 'Плюс у товара'],
		'anticon-minus': ['Уменьшили количество', 'Минус у товара'],
		'anticon-close': ['Закрыли окно', 'Крестик'],
		'icon-close': ['Закрыли окно', 'Крестик'],
		Каталог: ['Открыли каталог', 'Кнопка в шапке'],
		Меню: ['Открыли меню', 'Кнопка в шапке телефона'],
		close: ['Закрыли окно', 'Крестик'],
		Close: ['Закрыли окно', 'Крестик'],
		Закрыть: ['Закрыли окно', 'Крестик'],
		plus: ['Увеличили количество', 'Плюс у товара'],
		Plus: ['Увеличили количество', 'Плюс у товара'],
		minus: ['Уменьшили количество', 'Минус у товара'],
		Нальчик: ['Выбрали Нальчик', 'Переключатель города'],
		Москва: ['Выбрали Москву', 'Переключатель города'],
		Контакты: ['Открыли контакты', 'Пункт меню'],
		'О компании': ['Открыли «О компании»', 'Подвал сайта'],
		'Доставка и оплата': ['Открыли доставку и оплату', 'Пункт меню'],
		Вакансии: ['Открыли вакансии', 'Пункт меню'],
		Сертификаты: ['Открыли сертификаты', 'Пункт меню'],
		Новости: ['Открыли новости', 'Пункт меню'],
		'Оставить отзыв': ['Открыли отзыв', 'Пункт меню'],
		Акции: ['Открыли акции', 'Пункт меню'],
		Найти: ['Нажали поиск', 'Строка поиска'],
		Войти: ['Нажали «Войти»', 'Оформление или вход'],
		'В корзину': ['Нажали «В корзину»', 'Кнопка у товара'],
	};
	if (known[text]) return { title: known[text][0], where: known[text][1] };
	return { title: `Нажали «${text}»`, where: '' };
}

function describe(key) {
	if (EXACT[key]) return { title: EXACT[key][0], where: EXACT[key][1], group: EXACT[key][2] };
	if (key.startsWith('cat:')) {
		const name = CATS[key.slice(4)] || key.slice(4);
		return { title: `Открыли раздел «${name}»`, where: 'Плитка на главной', group: 'Главная' };
	}
	if (key.startsWith('product:')) {
		return { title: `Открыли товар №${key.slice(8)}`, where: 'Карточка товара', group: 'Товары' };
	}
	if (key.startsWith('cart:add:')) {
		return { title: `Добавили в корзину товар №${key.slice(9)}`, where: 'Кнопка «В корзину»', group: 'Корзина' };
	}
	if (key.startsWith('cart:plus:')) {
		return { title: `Увеличили количество товара №${key.slice(10)}`, where: 'Плюс у товара', group: 'Корзина' };
	}
	if (key.startsWith('cart:minus:')) {
		return { title: `Уменьшили количество товара №${key.slice(11)}`, where: 'Минус у товара', group: 'Корзина' };
	}
	if (key.startsWith('wish:')) {
		return { title: `Нажали избранное у товара №${key.slice(5)}`, where: 'Сердечко на карточке', group: 'Товары' };
	}
	if (key.startsWith('go:')) {
		const path = key.slice(3) || '/';
		return { title: `Перешли: ${pageTitle(path)}`, where: path, group: path.startsWith('/catalog') || path.startsWith('/product') ? 'Каталог' : 'Страницы' };
	}
	if (key.startsWith('ext:')) {
		return { title: hostTitle(key.slice(4)), where: 'Внешняя ссылка', group: 'Страницы' };
	}
	if (key.startsWith('tel:')) {
		return { title: `Позвонили на +${key.slice(4)}`, where: 'Телефон на сайте', group: 'Шапка и меню' };
	}
	if (key.startsWith('mail:')) {
		return { title: `Написали на ${key.slice(5)}`, where: 'Почта в подвале', group: 'Шапка и меню' };
	}
	if (key.startsWith('card:')) {
		const action = namedAction(key.slice(5));
		return { title: action.title, where: 'Блок качества на главной', group: 'Главная' };
	}
	const prefixed = key.match(/^(btn|a):(?:(Подвал|Шапка|Меню|Окно|Оформление|Товар|Главная|Каталог|Корзина):)?([\s\S]+)$/);
	if (prefixed) {
		const action = namedAction(prefixed[3]);
		const generic = !action.where || action.where === 'Пункт меню' || action.where === 'Ссылка' || action.where === 'Кнопка';
		const where = prefixed[2] && generic ? prefixed[2] : action.where || prefixed[2] || (prefixed[1] === 'a' ? 'Ссылка' : 'Кнопка');
		return {
			title: action.title,
			where,
			group: groupOf(key, where),
		};
	}
	return { title: key, where: 'Сайт', group: 'Остальное' };
}

function groupOf(key, where) {
	if (key.startsWith('cat:') || key === 'banner' || key === 'to-catalog' || key.startsWith('card:') || where === 'Главная') return 'Главная';
	if (key.startsWith('product:') || key.startsWith('wish:') || where === 'Товар') return 'Товары';
	if (key.startsWith('cart:') || where === 'Корзина' || where === 'Оформление' || where.includes('Плюс') || where.includes('Минус')) return 'Корзина';
	if (where === 'Подвал сайта') return 'Страницы';
	if (key.startsWith('nav:') || key.startsWith('tel:') || key.startsWith('mail:') || where === 'Шапка' || where === 'Меню' || where === 'Подвал' || where.includes('Соцсети')) return 'Шапка и меню';
	if (key.startsWith('city:') || where.startsWith('Окно') || where === 'Окно' || where === 'Крестик') return 'Окна';
	if (key.startsWith('go:/catalog') || key.startsWith('go:/product') || where === 'Каталог') return 'Каталог';
	if (key.startsWith('go:') || key.startsWith('ext:')) return 'Страницы';
	return 'Остальное';
}

const sumCity = map => Object.values(map || {}).reduce((acc, n) => acc + (Number(n) || 0), 0);

const SiteStats = () => {
	const [counts, setCounts] = useState({ 0: {}, 1: {} });
	const [query, setQuery] = useState('');
	const [group, setGroup] = useState('Все');
	const [copied, setCopied] = useState(false);

	useEffect(() => subscribeHomeClicks(setCounts), []);

	const allRows = useMemo(() => {
		const keys = new Set([...Object.keys(counts[0] || {}), ...Object.keys(counts[1] || {})]);
		const merged = new Map();
		keys.forEach(key => {
			const info = describe(key);
			const id = `${info.title}|${info.where}`;
			const prev = merged.get(id);
			const nalchik = Number(counts[0]?.[key]) || 0;
			const moscow = Number(counts[1]?.[key]) || 0;
			if (!prev) {
				merged.set(id, { key: id, ...info, nalchik, moscow });
				return;
			}
			prev.nalchik += nalchik;
			prev.moscow += moscow;
			if (prev.group === 'Остальное') prev.group = info.group;
		});
		return [...merged.values()].sort((a, b) => b.nalchik + b.moscow - (a.nalchik + a.moscow));
	}, [counts]);

	const rows = useMemo(() => {
		const q = query.trim().toLowerCase();
		return allRows.filter(row => (group === 'Все' ? true : row.group === group)).filter(row => {
			if (!q) return true;
			return `${row.title} ${row.where} ${row.group}`.toLowerCase().includes(q);
		});
	}, [allRows, query, group]);

	const nalchikTotal = sumCity(counts[0]);
	const moscowTotal = sumCity(counts[1]);
	const total = nalchikTotal + moscowTotal || 1;
	const nalchikShare = Math.round((nalchikTotal / total) * 100);
	const leader = allRows[0];

	const copyLink = async () => {
		try {
			await navigator.clipboard.writeText(`${window.location.origin}/stats`);
			setCopied(true);
			setTimeout(() => setCopied(false), 1600);
		} catch (e) {
			setCopied(false);
		}
	};

	return (
		<div className='region site-stats' data-click-ignore>
			<div className='site-stats-head'>
				<div>
					<p className='site-stats-kicker'>Дашборд</p>
					<h1 className='site-stats-title'>Что нажимают на сайте</h1>
					<p className='site-stats-lead'>
						Каждая строка — одно действие и место, где оно живёт. Синее — Нальчик, рыжее — Москва.
					</p>
				</div>
				<button type='button' className='site-stats-copy' onClick={copyLink}>
					{copied ? 'Ссылка скопирована' : 'Скопировать ссылку'}
				</button>
			</div>

			<div className='site-stats-kpis'>
				<article className='site-stats-kpi site-stats-kpi--nalchik'>
					<span>Нальчик</span>
					<strong>{nalchikTotal.toLocaleString('ru-RU')}</strong>
					<em>{nalchikShare}% всех кликов</em>
				</article>
				<article className='site-stats-kpi site-stats-kpi--moscow'>
					<span>Москва</span>
					<strong>{moscowTotal.toLocaleString('ru-RU')}</strong>
					<em>{100 - nalchikShare}% всех кликов</em>
				</article>
				<article className='site-stats-kpi site-stats-kpi--lead'>
					<span>Чаще всего</span>
					<strong>{leader ? leader.title : 'Пока пусто'}</strong>
					<em>{leader ? `${leader.where} · ${leader.nalchik + leader.moscow}` : 'Кликов ещё нет'}</em>
				</article>
			</div>

			<div className='site-stats-split' aria-hidden='true'>
				<i style={{ width: `${nalchikShare}%` }} />
			</div>
			<div className='site-stats-split-legend'>
				<span>Нальчик</span>
				<span>Москва</span>
			</div>

			<div className='site-stats-tools'>
				<div className='site-stats-chips'>
					{GROUPS.map(name => (
						<button
							key={name}
							type='button'
							className={name === group ? 'is-on' : ''}
							onClick={() => setGroup(name)}
						>
							{name}
						</button>
					))}
				</div>
				<input
					className='site-stats-search'
					value={query}
					onChange={e => setQuery(e.target.value)}
					placeholder='Найти действие'
				/>
			</div>

			<section className='site-stats-board'>
				<div className='site-stats-board-head'>
					<span>Действие</span>
					<span>Нальчик</span>
					<span>Москва</span>
				</div>
				{rows.length === 0 ? (
					<p className='site-stats-empty'>Ничего не нашлось.</p>
				) : (
					rows.map((row, index) => {
						const rowTotal = row.nalchik + row.moscow || 1;
						return (
							<div key={row.key} className='site-stats-item'>
								<div className='site-stats-item-main'>
									<span className='site-stats-rank'>{index + 1}</span>
									<div>
										<div className='site-stats-item-title'>{row.title}</div>
										<div className='site-stats-item-where'>{row.where}</div>
										<div className='site-stats-item-bar'>
											<i style={{ width: `${(row.nalchik / rowTotal) * 100}%` }} />
										</div>
									</div>
								</div>
								<div className='site-stats-item-num site-stats-item-num--nalchik'>
									{row.nalchik.toLocaleString('ru-RU')}
								</div>
								<div className='site-stats-item-num site-stats-item-num--moscow'>
									{row.moscow.toLocaleString('ru-RU')}
								</div>
							</div>
						);
					})
				)}
			</section>
		</div>
	);
};

export default SiteStats;
